<template>
  <div class="static-CampaignPage">
    <div class="staticCampaign">
      <div class="staticCampaign__header">
        <div class="staticCampaign__header__left">
          <div class="staticCampaign__header__left__search">
            <i class="adx-ic_search"></i>
            <input
              type="text"
              placeholder="Search Campaign"
              class="search"
              v-model="searchBoxValue"
            />
          </div>
          <adx-dropdown-list
            class="status"
            @selected="selectedStatus"
            :valueDisplay="selectedStatusValue"
            :list="statusList"
            :labelButton="labelStatus"
            :isCustomSet="isSelected"
          />
          <button v-if="filtered" class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
        <div class="staticCampaign__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" @selected="selectedSortStatus" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
    </div>
    <adx-table
      text="Tooltip button"
      :loading.sync="isLoading"
      :items.sync="data"
      :isEmpty.sync="isEmpty"
      @selectedAction="selectedAction"
      @download="downloadLogProof"
    ></adx-table>
    <div class="staticCampaign__footer">
      <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
      <adx-pagination
        v-if="!isLoading && !isEmpty"
        :max-page="maxPage"
        :selected-page="selectedPage"
        @change-page="selectPage"
      />
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/Primary"
import Pagination from "@/components/Pagination"
import DropdownSort from "@/components/Form/SelectDropdown"
import ListDropdown from "@/components/Dropdown/ListDropdown"
import table from "@/components/Table"
import LabelStatus from "@/components/StatusLabel"

import api from "@/api"
import FileSaver from "file-saver"
import lib from "@/lib/util"
import { apiV2 } from "@/api/urls"
import { parseErrorGql } from "@/lib/error"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { constants } from "crypto"

export default {
  name: "adx-campaign-bus",
  components: {
    "adx-loading": Loading,
    "adx-pagination": Pagination,
    "adx-dropdown-sort": DropdownSort,
    "adx-dropdown-list": ListDropdown,
    "adx-table": table,
    LabelStatus
  },
  props: {},
  data() {
    return {
      retryCount: 0,
      staticCampaign: null,
      isLoading: true,
      searchBoxValue: '',
      selectedStatusValue: '',
      selectedStatusLabel: '',
      selectedPage: 1,
      labelStatus: "All Status",
      count: 0,
      maxPage: 1,
      ds_campaign: [],
      static_campaign: [],
      selectedSortValue: '',
      isSelected: false,
      resetPage: false,
      sort: [
        {
          id: 0,
          label: "Created Date",
          value: "first_added"
        },
        {
          id: 1,
          label: "Last Updated",
          value: "last_updated"
        }
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "",
            type: "button"
          },
          // {
          //   title: "",
          //   type: "button"
          // },
          {
            title: "",
            type: "icon"
          },
          // {
          //   title: "",
          //   type: "icon"
          // },
          // {
          //   title: "",
          //   type: "icon"
          // }
        ],
        body: []
      },
      statusList: [
        {
          id: 0,
          label: "All",
          value: null
        },
        {
          id: 1,
          label: "Upcoming",
          value: "upcoming"
        },
        {
          id: 2,
          label: "Active",
          value: "active"
        },
        {
          id: 3,
          label: "Expired",
          value: "expired"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
    isEmpty: function() {
      return this.data.body && this.data.body.length ? false : true;
    },
    filtered: function() {
      let filtered = false;
      if (this.selectedStatusValue) {
        filtered = true;
      }
      return filtered;
    },
    getDataRange: function() {
      return (this.count % 15 === 0 || this.selectedPage === 1) &&
        this.count > 15
        ? this.selectedPage * 15
        : this.selectedPage * 15 - 15 + (this.count % 15);
    },
    getFilterParams: function() {
      const params = {
        sort_by: this.selectedSortValue || undefined,
        status: this.selectedStatusValue || undefined,
        search: this.searchBoxValue || undefined
      };
      return params;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      !this.resetPage ?  this.resetPage = true : this.selectedPage = 1
      this.loadData()
    }, 500)
  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    let query = this.$route.query;
    this.replaceRouter(query)
    this.setFiltersQuery(query);
  },

  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async setFiltersQuery(query) {
      this.searchBoxValue = query.search;
      this.selectedPage = query.page ? parseInt(query.page) : 1;
      this.selectedSortValue = query.sort_by ? query.sort_by : "last_updated";
      this.selectedStatus("isFromQuery", query.status);
    },
    replaceRouter(query) {
      this.$router.replace({
        query: {
          page: query.page,
          sort_by: query.sort_by,
          status: query.status,
          search: query.search
        }
      });
    },
    async loadData() {
      this.isLoading = true;
      let response = null;
      let params = {
        page: this.selectedPage,
        ...this.getFilterParams
      };

      response = await api.get(apiV2.dashboardStaticCampaign, {
        needToken: true,
        params
      });
      if (response.status == 200) {
        this.staticCampaign = response.data.results;
        this.mappingData(response.data);
      }
      this.setQueryRouter()
    },
    mappingData(data) {
      let body = [];
      let result = data.results;
      let lenres = result.length;
      let disabledText = "There is still no data for this report";
      let idx = 0;
      if (lenres > 0) {
        result.forEach(res => {
          let statusDisplay = this.displayStatus(res.status);
          let isHaveMeasurement = res.measurement_campaign ? false : true;
          let isUpComing = res.status === "Upcoming" ? true : false;
          let bast = true;
          let valuesData = [
            { value: res.id, display: "display:none;" },
            { value: statusDisplay.value, label: statusDisplay.label },
            { value: res.title },
            { start: res.start, end: res.end },
            {
              value: this.isSuperuser ? true : false,
              disabled: !(res.idooh_campaign.length > 0) || isUpComing,
              label: "Log Proof",
              icon: true,
              tooltip:
                !(res.idooh_campaign.length > 0) || isUpComing
                  ? disabledText
                  : "Download Log Proof"
            },
            // {
            //   value: true,
            //   disabled: bast,
            //   label: "BAST",
            //   icon: true,
            //   tooltip: bast ? disabledText : "Download Bast"
            // },
            { imgIcon: "/img/icons/adx-ic-eyes.svg", text: "View Detail" },
            // {
            //   imgIcon: "/img/icons/adx-ic-monitoring.svg",
            //   text: "View Monitoring"
            // },
            // {
            //   imgIcon: "/img/icons/adx-ic-measurement.svg",
            //   text: "View Measurement",
            //   isDisabled: isHaveMeasurement
            // }
          ];
          body.push({
            id: res.id,
            id_parent: res.id,
            idooh_id: res.idooh_campaign[0],
            values: valuesData
          });
        });
      } else {
        this.isLoading = false;
      }
      this.isLoading = false;
      this.data.body = body;
      this.maxPage = data.max_page;
      this.count = data.count;
    },
    async selectedSortStatus(items){
      this.selectedPage = 1;
      this.selectedSortValue = items.item.value
      await this.loadData()
    },
    async selectedStatus(item, query) {
      if (item == "isFromQuery") {
        let labelIndex = null;
        switch (query) {
          case "upcoming":
            labelIndex = 1;
            break;
          case "active":
            labelIndex = 2;
            break;
          case "expired":
            labelIndex = 3;
            break;
        }
        let status = this.statusList[labelIndex];
        if (status) {
          this.selectedStatusValue = status.value;
          this.labelStatus = status.label;
          this.isSelected = true;
        }
      } else {
        this.selectedPage = 1;
        this.selectedStatusValue = item.value;
        this.selectedStatusLabel = item.id.toString();
        await this.loadData()
      }
    },
    async resetFilter() {
      this.selectedPage = 1
      this.labelStatus = ''
      this.selectedStatusValue = ''
      this.selectedStatusLabel = ''
      this.isSelected = false
      this.getQuery();
      await this.loadData();
    },
    getQuery() {
      //get query value from variable for push route 
      return {
        page: this.selectedPage,
        sort_by: this.selectedSortValue || undefined,
        status: this.selectedStatusValue || undefined,
        search: this.searchBoxValue || undefined
      }
    },
    setQueryRouter() {
      //replace query in url
      this.$router.replace({ query: this.getQuery() });
    },
    async selectPage(item) {
      this.selectedPage = item;
      await this.loadData();
    },
    selectedAction(id, type, item, imgIcon) {
      let idooh_campaign = item.idooh_id;
      let label = item.values[1].value;
      let campaign_name = item.values[2].value;
      this.staticCampaign.map(el => {
        if (el.id == item.id) {
          this.ds_campaign = el.idooh_campaign;
          this.static_campaign = el.static_campaign;
        }
      });

      // push router query base icon in table component
      let router_name = null
      let router_param = null
      switch (imgIcon) {
        case "/img/icons/adx-ic-eyes.svg":
          this.ds_campaign.length > 0 ? router_name = "digitalscrdetail" : router_name = "exbrandingdetail"
          break;
        case "/img/icons/adx-ic-measurement.svg":
          router_name = "measurementstatic"
          break;
        default:
          this.ds_campaign.length > 0 ? router_name = "digitalscrmonitoring" : router_name = "exbrandmonitoring"
        }

        //set router params before push it
        router_name == 'measurementstatic' 
          ? router_param = { campaign_id: idooh_campaign, campaign: campaign_name }
          : router_param ={ id: item.id }

        //push router to next page base on router name
        this.$router.push({
              name: router_name,
              params: router_param,
              query: this.getQuery()
        });
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status);
    },
    async downloadLogProof(index, value, item) {
      let idooh_campaign_id = item.id;
      const response = await api.get(apiV2.logProofDS(idooh_campaign_id), {
        needToken: true,
        responseType: "blob"
      });
      if (response.status == 200) {
        const fileName = `log-proof-report.xlsx`;
        await FileSaver.saveAs(response.data, fileName);
        // this.downloadLoading = false;
      } else {
        let error = "Bad Request";
        if (response.status === 403) error = "Forbidden";
        if (response.status === 500) error = "Internal Server Error";
        this.downloadLoading = false;
        this.$notify({
          group: "saved",
          title: "Error",
          text: error,
          type: "danger"
        });
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
<style lang='scss'>
.static-CampaignPage {
  .table {
    height: 100%;
  }
  .table table tbody tr td .text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    width: 250px;
  }

  .table table tbody tr td .money {
    text-align: left;
  }
}
</style>